import './LoadingIndicator.scss';
import Component from './LoadingIndicator.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);